export default __webpack_public_path__ + "static/media/rnwy-wordmark-purple.3312fb73.png";